import { Field, FieldRootProps } from '@chakra-ui/react';
import FieldErrorMessage from './FieldErrorMessage';

export interface InputFieldProps extends FieldRootProps {
  message?: string;
  errorMessage?: string;
}

/**
 * @description
 * This is to wrap all input components for use in a form.
 */
export default function InputField({ message, errorMessage, ...props }: InputFieldProps) {
  return (
    <Field.Root {...props}>
      {props.children}
      {message && <Field.HelperText>{message}</Field.HelperText>}
      {errorMessage && <FieldErrorMessage>{errorMessage}</FieldErrorMessage>}
    </Field.Root>
  );
}
